import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { IImportSettingsPlaid } from './import-settings-plaid.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImportSettingsPlaidService {

  constructor(
    private firestore: AngularFirestore,
    private http: HttpClient,
  ) { }

  public getLinkToken(bankAccountId: string): Observable<string> {
    const url = `${environment.api}/import-plaid-linkToken?bankAccountId=${bankAccountId}`;
    return this.http.get<{linkToken: string}>(url).pipe(
      map((response) => response.linkToken),
    );
  }

  public getAccessToken(publicToken: string): Observable<string> {
    const url = `${environment.api}/import-plaid-accessToken?publicToken=${publicToken}`;
    return this.http.get<{accessToken: string}>(url).pipe(
      map((response) => response.accessToken),
    );
  }

  public get(bankAccountId: string): Observable<IImportSettingsPlaid | undefined> {
    const doc = `bank-accounts/${bankAccountId}/settings/import-plaid`;
    return this.firestore.doc<IImportSettingsPlaid>(doc).valueChanges();
  }

  public save(bankAccountId: string, settings: Partial<IImportSettingsPlaid>): Promise<void> {
    const doc = `bank-accounts/${bankAccountId}/settings/import-plaid`;
    return this.firestore.doc<Partial<IImportSettingsPlaid>>(doc).set(settings, {merge: true});
  }

}
